import React from "react";

const LoadingFallback = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <p className="text-lg font-semibold">Loading...</p>
    </div>
  );
};

export default LoadingFallback;
